// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","logos":"Footer_logos__iaJzm","logo1":"Footer_logo1__wol5g","logo2":"Footer_logo2__vsijs","disclaimer":"Footer_disclaimer__dfiK5"};